import getPermissionStatus from 'src/js/modules/extensions/registry/ws-image/helpers/get-permission-status';
import permissions from 'src/js/modules/extensions/registry/ws-image/constants/permissions';

const handleClipboardPermissionDenied = async (permissionName, setReason = true) => {
  const permissionStatus = await getPermissionStatus(permissionName);
  const res = { status: permissions.statuses.ALLOWED };

  if (!permissionStatus) {
    res.status = permissions.statuses.DENIED;

    if (setReason) {
      res.reason = permissions.permissionDeniedReasons.UNSUPPORTED_BROWSER;
    }
  }

  if (permissionStatus && permissionStatus === permissions.statuses.DENIED) {
    res.status = permissions.statuses.DENIED;

    if (setReason) {
      res.reason = permissions.permissionDeniedReasons.ACCESS_DENIED;
    }
  }

  return res;
};

export default handleClipboardPermissionDenied;
